import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-please-wait',
  templateUrl: './please-wait.component.html',
  styleUrls: ['./please-wait.component.scss']
})
export class PleaseWaitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
